import {
  Autocomplete,
  Badge,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip
} from "@mui/material";
import { ReactComponent as IconFilterSvg } from "assets/icon_filter.svg";
import Svg from "components/svg/svg";
import FilterEvents from "containers/events/filterEvents/filter-events";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { AppContext } from "helpers/context";
import { EventData } from "helpers/models";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./select-event.module.scss"
dayjs.extend(utc);
dayjs.extend(timezone);

interface Props {
  selectedEvent: EventData | null;
  setSelectedEvent: any;
  isDisabled: boolean;
}

export default function SelectEvent(props: Props) {
  const [context, dispatch] = useContext(AppContext);
  const [t] = useTranslation();

  const [filterEventsEl, setFilterEventsEl] = useState<null | HTMLElement>(
    null
  );
  const filterEventsOpen = Boolean(filterEventsEl);

  const [filterInvisible, setFilterInvisible] = useState(true);

  const [eventsList, setEventsList] = useState<any>(context.eventsList);

  const [checkedList, setCheckedList] = useState<any>(
    !eventsList || !eventsList.length
      ? []
      : eventsList.filter((e: any) => e.checked)
  );

  const handleFilterEventsClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setFilterEventsEl(event.currentTarget);
  };

  const handleFilterEventsClose = () => {
    setFilterEventsEl(null);
  };

  useEffect(() => {
    if (!context.eventsList || !context.eventsList.length) {
      setEventsList([]);
      setCheckedList([]);
      return;
    }

    setEventsList(context.eventsList);

    setCheckedList(eventsList.filter((e: any) => e.checked));
  }, [context.eventsList]);

  useEffect(() => {
    if (context.eventsList && context.eventsList.length > 0) {
      // handleCreatDefaultData();
    } else {
      setEventsList([]);
    }
  }, [context.eventsList, context.eventsFilterForm]);

  let filteredEvents = [];
  if (eventsList && eventsList.length) {
    filteredEvents = eventsList.filter((e: any) =>
      context.eventsFilterForm.type.includes(e.type)
    );
  }

  const options = checkedList.length ? checkedList : filteredEvents;

  return (
    <div>
      <div className={styles.title}>
        {t("events.Select Parameters")}
      </div>

      <div className="flex items-center gap-1 justify-between">
        <Autocomplete
          id="searchable-dropdown"
          className="flex-1"
          disabled={props.isDisabled}
          value={props.selectedEvent}
          onChange={(event, value) => {
            props.setSelectedEvent(value);
          }}
          options={options}
          getOptionLabel={(option: any) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("events.Event Name")}
              placeholder={t("addressEncoding.search")}
              margin="normal"
              variant="outlined"
              color="success"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <span className="material-icons-outlined">search</span>
                  </InputAdornment>
                )
              }}
              sx={{
                "& .MuiAutocomplete-input": {
                  fontSize: "13px"
                }
              }}
            />
          )}
          renderOption={(props, option: any, { selected }) => {
            return (
              <li
                {...props}
                style={{
                  backgroundColor: selected ? "#0e8a3f14" : ""
                }}
              >
                <div className="flex items-center">
                  <span style={{ marginRight: 8 }}>
                    {Svg({ icon: option.type, })()}
                  </span>
                  <span style={{ fontSize: "13px" }}>{option.name}</span>
                </div>
              </li>
            );
          }}
          filterOptions={(options, state) => {
            return options.filter((option) => {
              return option.name
                .toLowerCase()
                .includes(state.inputValue.toLowerCase());
            });
          }}
        />
        {!checkedList.length && (
          <Tooltip title={t("events.filterEvents")} placement="top">
            <Badge
              overlap="circular"
              variant="dot"
              invisible={filterInvisible}
              sx={{
                ".MuiBadge-badge": { background: "#ffa02f" }
              }}
            >
              <IconButton
                onClick={handleFilterEventsClick}
                color="success"
                sx={{
                  width: "36px",
                  height: "36px",
                  "&:hover": {
                    background: "rgba(0, 0, 0, 0.04)"
                  }
                }}
                style={{
                  background:
                    filterEventsOpen || !filterInvisible ? "#c1e5ca" : ""
                }}
              >
                <IconFilterSvg
                  style={{
                    fill: filterEventsOpen || !filterInvisible ? "green" : ""
                  }}
                  className="focus:outline-none w-[20px] h-[12px]"
                />
              </IconButton>
            </Badge>
          </Tooltip>
        )}
      </div>
      {filterEventsOpen && (
        <FilterEvents
          anchorEl={filterEventsEl}
          handleClose={handleFilterEventsClose}
        />
      )}
    </div>
  );
}
